import React from 'react';
import Navbar from '../components/Navbar';
import ExchangeHero from '../components/exchange/ExchangeHero';
import ExchangeProblem from '../components/exchange/ExchangeProblem';
import ExchangeSolution from '../components/exchange/ExchangeSolution';
import ExchangeFeatures from '../components/exchange/ExchangeFeatures';
import ExchangeAudience from '../components/exchange/ExchangeAudience';
import ExchangeIndustries from '../components/exchange/ExchangeIndustries';
import ExchangeIntegration from '../components/exchange/ExchangeIntegration';
import ExchangeCTA from '../components/exchange/ExchangeCTA';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const ExchangePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <SEO 
        title="Traain Exchange | The Enterprise Training Marketplace"
        description="Fresh, expert-led Training — continuously updated and ready to deploy. Access high-quality training programs powered by Navigator AI."
        keywords="enterprise training marketplace, expert-led training, AI-powered training, professional development, Navigator AI"
      />
      
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <ExchangeHero />
        <ExchangeProblem />
        <ExchangeSolution />
        <ExchangeFeatures />
        <ExchangeAudience />
        <ExchangeIndustries />
        <ExchangeIntegration />
        <ExchangeCTA />
        <Footer />
      </div>
    </div>
  );
};

export default ExchangePage;